/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free colour palette generator. Pick a base colour and get complementary, analogous, triadic, tetradic and monochromatic palettes with copyable hex codes.`)
};

const es_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de interés compuesto en línea. Ingresa un depósito, tasa de interés, años y frecuencia de capitalización para ver el saldo final e interés ganado. Funciona en tu navegador.`)
};

const de_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Zinseszinsrechner. Geben Sie Einzahlung, Zinssatz, Jahre und Zinseszinsperiode ein, um den Endsaldo und die erzielten Zinsen zu sehen. Funktioniert direkt in Ihrem Browser.`)
};

const nl_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online calculator voor samengestelde rente. Voer een inleg, rentepercentage, aantal jaren en renteverrekening in om het eindersaldo en verdiende rente te zien. Werkt in uw browser.`)
};

const fr_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'intérêt composé en ligne gratuite. Entrez un dépôt, un taux d'intérêt, des années et une fréquence de composition pour voir le solde final et les intérêts gagnés. Fonctionne dans votre navigateur.`)
};

const it_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito dell'interesse composto online. Inserisci un deposito, tasso di interesse, anni e frequenza di capitalizzazione per visualizzare il saldo finale e l'interesse guadagnato. Funziona nel tuo browser.`)
};

const pt_br2_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de juros compostos online gratuita. Digite um depósito, taxa de juros, anos e frequência de capitalização para ver o saldo final e os juros obtidos. Funciona no seu navegador.`)
};

const pt_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de juros compostos online. Introduza um depósito, taxa de juros, anos e frequência de capitalização para ver o saldo final e o juro ganho. Funciona no seu navegador.`)
};

const ja_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンライン複利計算ツール。預金、利率、年数、複利計算期間を入力すると、最終残高と利息を確認できます。ブラウザ内で機能します。`)
};

const zh_cp_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线复利计算器。输入存款金额、利率、年数和复利周期，即可查看最终余额和所赚取的利息。可在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_meta_description", locale)
	if (locale === "en") return en_cp_meta_description(inputs)
	if (locale === "es") return es_cp_meta_description(inputs)
	if (locale === "de") return de_cp_meta_description(inputs)
	if (locale === "nl") return nl_cp_meta_description(inputs)
	if (locale === "fr") return fr_cp_meta_description(inputs)
	if (locale === "it") return it_cp_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_cp_meta_description(inputs)
	if (locale === "pt") return pt_cp_meta_description(inputs)
	if (locale === "ja") return ja_cp_meta_description(inputs)
	return zh_cp_meta_description(inputs)
};